import styles from "./Button.module.scss";

const Button = ({
	href,
	onClick,
	as,
	target = "_self",
	className = "",
	reverseSkew = false,
	inverse = false,
	children,
}) => {
	const Component = as ? as : "a";
	return (
		<Component
			href={href}
			to={href}
			target={target}
			onClick={onClick}
			className={`${styles.button} ${
				reverseSkew && styles.reverse
			} ${className} ${inverse && styles.inverse}`}
		>
			<p className="uppercase">{children}</p>
		</Component>
	);
};

export default Button;
